const {
  Message,
  Loading,
  MessageBox,
  Image: {
    components: { ImageViewer }
  }
} = ELEMENT;

let dialogOpening = false;

let viewerVm = null;

let xssWhiteList = {
  b: ["style", "class"],
  span: ["style", "class"],
  font: ["style", "class"],
  div: ["style", "class"],
  br: ["style", "class"],
  p: ["style", "class"],
  h1: ["style", "class"],
  h2: ["style", "class"],
  h3: ["style", "class"],
  h4: ["style", "class"],
  h5: ["style", "class"],
  h6: ["style", "class"],
  pre: ["style", "class"],
  svg: ["class", "viewBox", "xmlns", "width", "height", "style"],
  img: ["style", "class"],
  ul: ["style", "class"],
  li: ["style", "class"],
  ol: ["style", "class"]
};

const messageType = {
  1: "success",
  2: "warning",
  0: "error"
};

export default {
  openWindow(isNew, options, callback) {
    if (!dsf.isBoolean(isNew)) {
      options = isNew;
      isNew = false;
    }
    if (dsf.isString(options)) {
      let url = "";
      url = options;
      options = {};
      options.url = url;
    }
    // 如果在多页签架构下
    if (_spv_ && !isNew) {
      multiPageWindowOpen.call(this, options, callback);
    } else {
      // 碰到钉钉PC客户端window.open的bug处理,
      if (window.dd) {
        dingdingWindowOpen.call(this, options, callback);
      } else {
        browserWindowOpen.call(this, options, callback);
      }
    }
  },
  openDialog(options, destroyed) {
    let defaultConent = "DsfViewPart";
    if (!dialogOpening) {
      options = options || {};
      dialogOpening = true;
      let openerVm = options.openerVm ? options.openerVm : this._isVue ? this : null;
      let comp = null;
      if (options) {
        if (!options.template) {
          if (options.params && options.params.path && !options.content) {
            options.content = defaultConent;
          }
          if (options.content == defaultConent) {
            options.params.showModel = "full";
            options.params.isOpenDialog = true;
            options.params.forceUpdate = false;
          }
          if (options.content && !dsf.isString(options.content) && options.content.name) {
            comp = {
              name: options.content.name + "DialogCopy",
              inject: {
                $dialog: {
                  default: null
                }
              },
              mixins: [options.content]
            };
            options.content = comp.name;
          }
        }
        if (options && options.version == "4.0") {
          if (options.height.endsWith("%")) {
            options.height =
              "calc(" +
              options.height.replace("%", "vh") +
              " - " +
              (options.btns ? "94px" : "44px") +
              ")";
          }
        }
      }

      let app = dsf.getVueAppRoot();
      let router = this.$router || app?.$options?.router || options.router;
      let store = this.$store || app?.$options?.store || options.store;
      let i18n = this.$i18n || app?.$options?.i18n || options.i18n;
      let service = openerVm ? openerVm.$service : {};
      let appRoot = router ? router.apps[0] : app;
      let _self = window;
      let component = null;
      let top = dsf.getTopWindow();
      if (dsf.isUnDef(options.isTopOpen)) {
        options.isTopOpen = dsf.config.component.topOpenDialog || false;
      }
      let elConfig = {
        router,
        store: store,
        i18n: i18n,
        components: options.components || undefined,
        provide() {
          return {
            $serviceInfo: service
          };
        },
        beforeCreate() {
          if (openerVm && openerVm._routerRoot) {
            this._routerRoot = openerVm._routerRoot;
          } else {
            this._routerRoot = this._routerRoot =
              (this.$parent && this.$parent._routerRoot) || this;
          }
        },
        data: function () {
          // if (options.isTopOpen === true) {
          //   this.appendToDom = top.document.body;
          //   this.zIndex = top.ELEMENT.Image.components.ImageViewer.computed.viewerZIndex();
          // } else {
          //   this.appendToDom = undefined;
          //   this.zIndex = undefined;
          // }
          return {
            appendToBody: true,
            index: dsf.uuid(),
            dialogVisible: false,
            clearDialog: false,
            clearConent: false,
            //标题
            title: dsf.isDef(options.title) ? options.title : "对话框",
            //组件名称
            content: options.content,
            noTitle: options.noTitle,
            width: options.width || "50%",
            height: options.height || "auto",
            destroyOnClose: true,
            params: options.params || {},
            overflow: options.overflow || "auto",
            // 底部left居左,center居中,right居右
            footerAlign: options.footerAlign || "right",
            btns: options.btns || [],
            events: options.event,
            fullscreen: options.fullscreen,
            openerVm: openerVm,
            dialogArgs: options.dialogArgs || null,
            top: options.top || "10vh",
            yes: options.yes || dsf.noop,
            showClose: dsf.isDef(options.showClose) ? options.showClose : true,
            modal: dsf.isDef(options.modal) ? options.modal : true,
            center: dsf.isDef(options.center) ? options.center : false,
            closed: options.closed || dsf.noop,
            conentBorder: options.conentBorder || null,
            customClass: options.customClass || "",
            draggable: dsf.isUnDef(options.draggable) ? true : options.draggable,
            /**
             * 弹窗自动关闭配置，可选值 close自动关闭，disabled:禁止路由切换，ignore：忽略除调用关闭方法或者手动关闭以外任何变化
             */
            autoCloseConfig: dsf.mix(true, {}, options.autoCloseConfig || {}, {
              //路由变化时配置
              routerChange: "close"
            })
            // routeChangeAutoClose: options.routeChangeAutoClose === void 0 ? true : !!options.routeChangeAutoClose
          };
        },
        computed: {
          options() {
            return options;
          }
        },
        created() {
          this.setViewLoadedButtonsState(true);
          if (this.height.endsWith("%")) {
            this.height = this.height.replace("%", "vh");
          }
        },
        mounted() {
          if (options.content == defaultConent || this.template) {
            this.$nextTick(() => {
              options.dialogLoaded &&
                options.dialogLoaded(options.content == defaultConent ? this.$refs.content : null);
            });
          }
        },
        destroyed() {
          for (let k in this._data) {
            this._data[k] = null;
          }
          dsf.array.remove(appRoot?.$dialogAll || [], this);
          options = null;
          openerVm = null;
          app = null;
          router = null;
          store = null;
          i18n = null;
          _self = null;
          service = null;
          this._routerRoot = null;
          destroyed && destroyed();
        },
        methods: {
          async dialogSure(result) {
            await options.yes?.(this.$refs.content);
            this.close();
          },
          async clickHandler(button) {
            if (!this.dialogVisible || button.disabled) {
              return;
            }
            button.disabled = true;
            let result = true;
            let vm = this;
            if (button.handler) {
              //如果是4.0版本老系统调用,必须要兼容，无奈 :-(
              try {
                if (options && options.version == "4.0") {
                  result = await button.handler(
                    null,
                    $(vm.$refs.content.$el),
                    vm.$refs.content.contentWindow
                  );
                } else {
                  result = await button.handler(vm.$refs.content);
                }
              } catch (err) {
                console.error(err);
                result = false;
              }
            }
            if (result !== false) {
              vm.close();
            }
            button.disabled = false;
            vm = null;
          },
          onDialogMounted() {
            this.dialogVisible = true;
          },
          onOpened() {
            let fn = options.onOpened;
            dsf.isFunction(fn) && fn();
            dsf.resizeComponent(this.$refs.instance);
          },
          close() {
            this.$refs?.instance?.close?.();
          },
          onClosed() {
            if (this.closed) {
              if (options && options.version == "4.0") {
                this.closed(this.index, $(this.$el));
              } else {
                this.closed(this.$refs.content);
              }
              options.onClosed?.();
            }
          },
          cancel() {
            let _this = this;
            if (component) {
              component = null;
            }
            this.$nextTick().then(() => {
              this.clearConent = true;
              if (this.content == "DsfDialogIframe") {
                this.$refs.content.destoryIframe();
              }
              let closeId = window.setTimeout(() => {
                closeId && window.clearTimeout(closeId);
                _this.$destroy();
                this.$nextTick().then(() => {
                  if (_this._vnode) {
                    _this._vnode = null;
                  }
                  if (_this?.$el) {
                    _this.$el.__vue__ = null;
                  }
                  _this.$el = null;
                  _this = null;
                  //
                  //处理一些el-dialog奇奇怪怪的内存泄漏问题
                  try {
                    //chrome的bug，当一个被聚焦过的文本框被移除，会导致该文本框相关内存无法销毁，
                    //因为文本框节点又有parentNode引用父节点，从而导致一连串dom对象无法被释放
                    dsf.memoryRelease();
                  } catch (ex) {
                    //todo
                  }
                });
              }, 1000);
            });
          },
          contentReady() {
            this.setViewLoadedButtonsState(false);
          },
          setViewLoadedButtonsState(state) {
            if (this.options.content == "DsfViewPart") {
              _.each(this.btns || [], (btn) => {
                this.$set(btn, "disabled", state);
              });
            }
          }
        },
        template: `
        <DsfDialog
          v-if="!clearDialog"
          :key="index"
          ref="instance"
          :class="[
            {
              'has-button-bar': btns.length,
            },
            'ds-dialog-show-animation',
            customClass]"
          :no-title="noTitle"
          :conent-border="conentBorder"
          :title="title" 
          :top="top" 
          :index="index" 
          :options="options"
          :visible.sync="dialogVisible"
          :fullscreen="fullscreen" 
          :width="width" 
          :close-on-click-modal="false" 
          :append-to-body="appendToBody"
          :show-close="showClose" 
          :close-on-press-escape="false" 
          :dialog-args="dialogArgs"
          :modal="modal" 
          :center="center" 
          :opener-vm="openerVm" 
          :footer-align="footerAlign"
          :allow-draggable="draggable"
          @opened="onOpened"
          @close="onClosed"
          @closed="cancel"
          @hook:mounted="onDialogMounted">
          <template v-slot:title>
            <div v-html="dsf.safe.xss(title)" class="el-dialog__title"></div>
          </template>
          <div class="ds-dialog-content" ref="contentWrapper" :style="{'position':'relative','height':(fullscreen?'100%':height),'overflow':overflow}">
            <template>
            ${
              options.template
                ? options.template
                : `<component 
                v-if="!clearConent"
                :key="'dialog-content-'+index"
                :is="content" 
                v-bind.sync="params" 
                ref="content" 
                v-on="events" 
                ${options.content == "DsfViewPart" ? '@ready="contentReady"' : ""}
                @dialog-yes="dialogSure">
              </component>`
            }
            </template>
          </div>
          <template v-slot:footer>
            <DsfButton 
              size="${options.btnSize || ""}"
              :disabled="button.disabled"
              :btn-index="$index"
              v-for="(button,$index) in btns" 
              :key="$index" 
              :class="button.class" 
              :text="button.text" 
              :type="dsf.isDef(button.type)?button.type:($index==0?'':'plain')"
              :icon="button.icon"
              :loading="button.loading"
              @click="clickHandler(button)"
              >
            </DsfButton>
          </template>
        </DsfDialog>`
      };
      if (comp) {
        elConfig.components = {
          [options.content]: comp
        };
      }
      if (options.btns) {
        _.each(options.btns, (btn) => {
          if (btn.handler) {
            btn.handler = btn.handler.bind(_self);
          }
        });
      }
      let Dialog = null;
      let comment = null;
      if (options.isTopOpen) {
        Dialog = top.Vue.extend(elConfig);
      } else {
        Dialog = Vue.extend(elConfig);
      }
      component = new Dialog();
      let div = top.document.createElement("div");
      top.document.body.appendChild(div);
      component.$mount(div);

      if (appRoot) {
        if (dsf.isUnDef(appRoot.$dialogAll)) {
          appRoot.$dialogAll = [];
        }
        appRoot.$dialogAll.push(component);
      }
      dialogOpening = false;
      return component;
    }
  },
  openDrawer(options = {}, destroyed) {
    if (!dialogOpening) {
      dialogOpening = true;
      let defaultConent = "DsfViewPart";
      let openerVm = options.openerVm ? options.openerVm : this._isVue ? this : null;
      let comp = null;
      if (!options.template) {
        if (options.params && options.params.path && !options.content) {
          options.content = defaultConent;
        }
        if (options.content == defaultConent) {
          options.params.showModel = "full";
          options.params.isOpenDialog = true;
          options.params.forceUpdate = false;
        }
        if (options.content && !dsf.isString(options.content) && options.content.name) {
          comp = {
            name: options.content.name + "DialogCopy",
            inject: {
              $dialog: {
                default: null
              }
            },
            mixins: [options.content]
          };
          options.content = comp.name;
        }
      }
      if (options && options.version == "4.0") {
        if (options.height.endsWith("%")) {
          options.height =
            "calc(" +
            options.height.replace("%", "vh") +
            " - " +
            (options.btns ? "94px" : "44px") +
            ")";
        }
      }

      let app = dsf.getVueAppRoot();
      let router = this.$router || app?.$options?.router || options.router;
      let store = this.$store || app?.$options?.store || options.store;
      let i18n = this.$i18n || app?.$options?.i18n || options.i18n;
      let service = openerVm ? openerVm.$service : {};
      let appRoot = router ? router.apps[0] : app;
      let _self = window;
      if (options.btns) {
        _.each(options.btns, (btn) => {
          if (btn.handler) {
            btn.handler = btn.handler.bind(_self);
          }
        });
      }
      let component = null;
      let top = dsf.getTopWindow();
      if (dsf.isUnDef(options.isTopOpen)) {
        options.isTopOpen = dsf.config.component.topOpenDialog || false;
      }
      let elConfig = {
        router,
        store: store,
        i18n: i18n,
        components: options.components || undefined,
        provide() {
          return {
            $serviceInfo: service
          };
        },
        data() {
          return {
            index: dsf.uuid(),
            openerVm,
            dialogVisible: false,
            clearConent: false,
            //组件名称
            content: options.content,
            noTitle: options.noTitle,
            size: options.size || "30%",
            // Drawer 打开的方向，取值rtl / ltr / ttb / btt
            direction: options.direction || "rtl",
            dialogArgs: options.dialogArgs || null,
            conentBorder: options.conentBorder || null,
            customClass: options.customClass || "",
            // 底部left居左,center居中,right居右
            footerAlign: options.footerAlign || "right",
            params: options.params || {},
            btns: options.btns || [],
            events: options.event || [],
            closed: options.closed || dsf.noop,
            yes: options.yes || dsf.noop,
            //标题
            title: dsf.isDef(options.title) ? options.title : "对话框",
            showClose: dsf.isDef(options.showClose) ? options.showClose : true,
            modal: dsf.isDef(options.modal) ? options.modal : true,
            /**
             * 弹窗自动关闭配置，可选值 close自动关闭，disabled:禁止路由切换，ignore：忽略除调用关闭方法或者手动关闭以外任何变化
             */
            autoCloseConfig: dsf.mix(true, {}, options.autoCloseConfig || {}, {
              //路由变化时配置
              routerChange: "close"
            })
          };
        },
        computed: {
          options() {
            return options;
          }
        },
        beforeCreate() {
          if (openerVm && openerVm._routerRoot) {
            this._routerRoot = openerVm._routerRoot;
          } else {
            this._routerRoot = this._routerRoot =
              (this.$parent && this.$parent._routerRoot) || this;
          }
        },
        created() {
          this.setViewLoadedButtonsState(true);
        },
        mounted() {
          if (options.content == defaultConent || this.template) {
            this.$nextTick(() => {
              options.dialogLoaded &&
                options.dialogLoaded(options.content == defaultConent ? this.$refs.content : null);
            });
          }
        },
        destroyed() {
          for (let k in this._data) {
            this._data[k] = null;
          }
          dsf.array.remove(appRoot?.$dialogAll || [], this);
          options = null;
          openerVm = null;
          app = null;
          router = null;
          store = null;
          i18n = null;
          _self = null;
          service = null;
          this._routerRoot = null;
          destroyed && destroyed();
        },
        render(h) {
          let classList = ["ds-dialog-show-animation", this.customClass];
          if (this.btns.length) {
            classList.push("has-button-bar");
          }
          return (
            <dsf-drawer
              ref="instance"
              class={classList}
              key={this.index}
              size={this.size}
              index={this.index}
              modal={this.modal}
              options={this.options}
              no-title={this.noTitle}
              opener-vm={this.openerVm}
              direction={this.direction}
              show-close={this.showClose}
              visible={this.dialogVisible}
              dialog-args={this.dialogArgs}
              footer-align={this.footerAlign}
              conent-border={this.conentBorder}
              close-on-press-escape={false}
              wrapper-closable={false}
              on={{
                opened: this.onOpened,
                close: this.onClosed,
                closed: this.cancel,
                "hook:mounted": this.onDialogMounted,
                "update:visible": (v) => {
                  this.dialogVisible = v;
                }
              }}
              scopedSlots={{
                title: () => {
                  return <div class="el-dialog__title">{dsf.safe.xss(this.title)}</div>;
                },
                default: () => {
                  let events = {
                    ...this.events,
                    "dialog-yes": this.dialogSure
                  };
                  if (options.content == "DsfViewPart") {
                    events.ready = this.contentReady;
                  }
                  _.each(this.params, (p, k) => {
                    events["update:" + k] = (e) => {
                      this.$set(this.params, p, e);
                    };
                  });
                  let child = options.template;
                  if (!child && !this.clearConent) {
                    child = h(this.content, {
                      attrs: this.params,
                      props: this.params,
                      ref: "content",
                      on: events
                    });
                  }
                  let res = [
                    <div class="ds-drawer-content">
                      <div
                        class="ds-dialog-content"
                        ref="contentWrapper"
                        style={{ overflow: this.overflow }}
                      >
                        {child}
                      </div>
                    </div>
                  ];
                  if (this.btns.length) {
                    res.push(
                      <div class="ds-drawer-footer">
                        {_.map(this.btns, (bt, index) => {
                          return (
                            <dsf-button
                              size={options.btnSize || ""}
                              disabled={bt.disabled}
                              btn-index={index}
                              class={bt.class}
                              text={bt.text}
                              type={dsf.isDef(bt.type) ? bt.type : !index ? "" : "plain"}
                              icon={bt.icon}
                              loading={bt.loading}
                              on-click={() => this.clickHandler(bt)}
                            />
                          );
                        })}
                      </div>
                    );
                  }
                  return res;
                }
              }}
            />
          );
        },
        methods: {
          async dialogSure() {
            await options.yes?.(this.$refs.content);
            this.close();
          },
          async clickHandler(button) {
            if (!this.dialogVisible) {
              return;
            }
            let result = true;
            let vm = this;
            if (button.handler) {
              //如果是4.0版本老系统调用,必须要兼容，无奈 :-(
              try {
                if (options && options.version == "4.0") {
                  result = await button.handler(
                    null,
                    $(vm.$refs.content.$el),
                    vm.$refs.content.contentWindow
                  );
                } else {
                  result = await button.handler(vm.$refs.content);
                }
              } catch (err) {
                console.error(err);
                result = false;
              }
            }
            if (result !== false) {
              vm.close();
            }
            vm = null;
          },
          onDialogMounted() {
            this.dialogVisible = true;
          },
          onOpened() {
            let fn = options.onOpened;
            dsf.isFunction(fn) && fn();
            dsf.resizeComponent(this.$refs.instance);
          },
          close() {
            this.$refs?.instance?.close?.();
          },
          onClosed() {
            if (this.closed) {
              if (options && options.version == "4.0") {
                this.closed(this.index, $(this.$el));
              } else {
                this.closed(this.$refs.content);
              }
              options.onClosed?.();
            }
          },
          cancel() {
            let _this = this;
            if (component) {
              component = null;
            }
            this.$nextTick().then(() => {
              this.clearConent = true;
              if (this.content == "DsfDialogIframe") {
                this.$refs.content.destoryIframe();
              }
              let closeId = window.setTimeout(() => {
                closeId && window.clearTimeout(closeId);
                _this.$destroy();
                this.$nextTick().then(() => {
                  if (_this._vnode) {
                    _this._vnode = null;
                  }
                  if (_this?.$el) {
                    _this.$el.__vue__ = null;
                  }
                  _this.$el = null;
                  _this = null;
                  //
                  //处理一些el-dialog奇奇怪怪的内存泄漏问题
                  try {
                    //chrome的bug，当一个被聚焦过的文本框被移除，会导致该文本框相关内存无法销毁，
                    //因为文本框节点又有parentNode引用父节点，从而导致一连串dom对象无法被释放
                    dsf.memoryRelease();
                  } catch (ex) {
                    //todo
                  }
                });
              }, 1000);
            });
          },
          contentReady() {
            this.setViewLoadedButtonsState(false);
          },
          setViewLoadedButtonsState(state) {
            if (this.options.content == "DsfViewPart") {
              _.each(this.btns || [], (btn) => {
                this.$set(btn, "disabled", state);
              });
            }
          }
        }
      };
      if (comp) {
        elConfig.components = {
          [options.content]: comp
        };
      }
      let Dialog = options.isTopOpen ? top.Vue.extend(elConfig) : Vue.extend(elConfig);
      component = new Dialog();
      let div = document.createElement("div");
      document.body.appendChild(div);
      component.$mount(div);
      dialogOpening = false;
      return component;
    }
  },
  closeWindow(win, vm) {
    //关闭窗口，兼容dialog,window.open，tab打开页面
    try {
      if (vm?.$dialog) {
        vm.$dialog.close();
      }
      // 如果在单页面模板中
      else if (_spv_) {
        let window_id = win.frameElement.getAttribute("wid");
        _spv_.closePage(window_id);
      } else {
        let _opener = window.fromWindow || window.opener;
        if (_opener) {
          if (_opener?.openerVms?.[win.name]) {
            delete _opener.openerVms[win.name];
          }
          _opener.openerVm = null;
          window.dialogArgs = null;
          _opener = null;
          window.close();
        } else if (window.frameElement && window.frameElement.$dialog) {
          window.frameElement.$dialog.close();
          // 父页面关闭时候 生效 拷贝的地址关闭  不生效
        } else {
          window.close();
        }
      }
    } catch (ex) {
      dsf.error(ex);
      window?.close?.();
    }
  },
  loading: function (options) {
    let opts = {
      background: "rgba(255,255,255,0.5)",
      text: ""
    };
    let loadingInstance = Loading.service(dsf.mix(opts, options || {}));
    return loadingInstance;
  },
  closeLoading: function (loadInstance) {
    loadInstance && loadInstance.close();
  },
  message: function (options, type) {
    let _Message = dsf.getTopWindow().ELEMENT.Message;
    if (dsf.isString(options)) {
      options = {
        message: options
      };
    }
    if (!dsf.isObject(options) && !dsf.isError(options)) {
      options = {};
    }
    if (dsf.isDef(options.type)) {
      type = options.type;
    }
    let _type = dsf.config.message.success;
    if (dsf.isBoolean(type)) {
      _type = type === false ? dsf.config.message.error : dsf.config.message.success;
    } else {
      _type = messageType[type ?? 1];
    }
    if (dsf.isString(options.message)) {
      options.message = dsf.safe.xss(options.message, {
        overrideWhiteList: xssWhiteList
      });
    }
    setTimeout(() => {
      (_Message[_type] || _Message)(options);
    }, 0);
  },
  alert: function (options) {
    if (dsf.isString(options)) {
      options = {
        message: options
      };
    }
    let defaultOptions = {
      confirmButtonText: "确定",
      type: "",
      top: "10vh",
      dangerouslyUseHTMLString: true,
      title: "提示",
      message: "",
      customClass: dsf.config.message.box.customClass.join(" ")
    };
    dsf.mix(defaultOptions, options);
    if (dsf.isString(defaultOptions.message)) {
      defaultOptions.message = dsf.safe.xss(defaultOptions.message, {
        overrideWhiteList: xssWhiteList
      });
    }
    let msgBox = dsf.getTopWindow().ELEMENT.MessageBox;
    return msgBox.alert(defaultOptions.message, defaultOptions.title, defaultOptions);
  },
  confirm: function (options) {
    if (dsf.isString(options)) {
      options = {
        message: options
      };
    }
    let defaultOptions = {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "",
      top: "10vh",
      dangerouslyUseHTMLString: true,
      title: "提示",
      message: "",
      customClass: dsf.config.message.box.customClass.join(" ")
    };
    dsf.mix(defaultOptions, options);
    if (dsf.isString(defaultOptions.message)) {
      defaultOptions.message = dsf.safe.xss(defaultOptions.message, {
        overrideWhiteList: xssWhiteList
      });
    }

    let msgBox = dsf.getTopWindow().ELEMENT.MessageBox;
    return msgBox.confirm(defaultOptions.message, defaultOptions.title, defaultOptions);
  },
  prompt: function (options) {
    let defaultOptions = {
      message: options.message || "",
      title: options.title || "",
      confirmButtonText: options.confirmButtonText || "确定",
      cancelButtonText: options.cancelButtonText || "取消",
      inputPattern: options.inputPattern || undefined,
      inputErrorMessage: options.inputErrorMessage || "格式不正确",
      inputType: options.inputType || "text",
      inputPlaceholder: options.inputPlaceholder || "",
      inputValidator: options.inputValidator || dsf.noop,
      closeOnClickModal: options.closeOnClickModal,
      inputValue: options.inputValue
      // dangerouslyUseHTMLString: true
    };
    if (dsf.isString(defaultOptions.message)) {
      defaultOptions.message = dsf.safe.xss(defaultOptions.message, {
        overrideWhiteList: xssWhiteList
      });
    }
    let msgBox = dsf.getTopWindow().ELEMENT.MessageBox;
    return msgBox.prompt(defaultOptions.message, defaultOptions.title, {
      dangerouslyUseHTMLString: true,
      confirmButtonText: defaultOptions.confirmButtonText,
      cancelButtonText: defaultOptions.cancelButtonText,
      inputPattern: defaultOptions.inputPattern,
      inputErrorMessage: defaultOptions.inputErrorMessage,
      inputType: defaultOptions.inputType,
      inputPlaceholder: defaultOptions.inputPlaceholder,
      inputValidator: defaultOptions.inputValidator,
      closeOnClickModal: defaultOptions.closeOnClickModal,
      inputValue: defaultOptions.inputValue
    });
  },
  /**
   * 预览图片
   * @param opt {String[] | {images: String[], startPosition: number, onClose: function}}
   */
  imagePreview: function (opt) {
    if (!opt) {
      dsf.error("imagePreview() 参数不能为空");
      return;
    }
    let images,
      startPosition = 0;
    if (dsf.isArray(opt)) {
      images = opt;
    } else if (dsf.isObject(opt) && opt.images) {
      images = opt.images;
      startPosition = opt.startPosition || 0;
    } else {
      dsf.error("imagePreview() 参数错误");
      return;
    }
    let top = dsf.getTopWindow();
    if (viewerVm) {
      top.document.body.removeChild(viewerVm.$el);
      viewerVm.$destroy();
      viewerVm = null;
    }
    let el = document.createElement("div");
    top.document.body.appendChild(el);
    const viewer = Vue.extend({
      name: "DsfImageViewer",
      components: { ImageViewer },
      template: `<image-viewer v-show="show" v-bind="options"/>`,
      data() {
        return {
          show: false,
          options: {
            urlList: images,
            initialIndex: startPosition,
            onClose: this.onClose
          }
        };
      },
      mounted() {
        this.show = true;
      },
      methods: {
        onClose() {
          try {
            //解决iframe页面无法关闭预览图片问题
            top.document.body.removeChild(viewerVm.$el);
          } catch (error) {
            console.error(error)
          }
          viewerVm.$destroy();
          viewerVm = null;
          opt?.onClose?.();
        }
      }
    });
    viewerVm = new viewer({ el });
  }
};

let $openVms = {};
//多tab页签模式下打开窗口
function multiPageWindowOpen(options, callback) {
  let defaultOptions = {
    openerVm: this._isVue ? this : null,
    url: "",
    dialogArgs: null
  };
  options = dsf.mix(defaultOptions, options);
  if (options.url.startsWith("#/")) {
    options.url = "./page.html" + options.url;
  }
  options.name = options.name?.trim();
  let windowName = !options.name ? dsf.uuid() : options.name;
  options.url = dsf.url.getWebPath(options.url);
  if (!window.dialogArgs) {
    window.dialogArgs = {};
  }
  if (!window.openerVms) {
    window.openerVms = {};
  }
  let arg = options.dialogArgs ? JSON.stringify(options.dialogArgs) : null;
  // window.openerVms[windowName] = options.openerVm;
  _spv_.openPage({
    name: windowName,
    url: options.url,
    dialogArgs: arg,
    openerVm: options.openerVm,
    opener: window,
    callback
  });
}
//dingding中打开窗口
function dingdingWindowOpen(options, callback) {
  options.name = options.name?.trim();
  let windowName = !options.name ? dsf.uuid() : options.name;
  let topAppElement = null;
  try {
    //如果top窗口有访问权限时
    topAppElement = window.top.document.querySelector("#app");
  } catch (ex) {
    //如果top窗口无访问权限时访问当前窗体本身
    topAppElement = window.document.querySelector("#app");
  }
  let app = topAppElement ? topAppElement?.__vue__ : null;
  let coefficient = 20;
  let $win = $(window);
  let width = $win.width() - coefficient;
  let height = $win.height() - coefficient;
  let offsetTop = ($win.height() - height) / 2;
  let win = app.$openDialog({
    content: "DsfDialogIframe",
    title: "",
    params: {
      rmiframeUrl: dsf.url.getWebPath(options.url)
    },
    width: width + "px",
    height: height - (44 + 20) + "px",
    // fullscreen: true,
    dialogArgs: options.dialogArgs || null,
    openerVm: this,
    conentBorder: true,
    top: offsetTop + "px"
  });
  callback?.(win);
  return win;
}

//浏览器原生window.open
function browserWindowOpen(options, callback) {
  let defaultOptions = {
    openerVm: this._isVue ? this : null,
    url: "",
    dialogArgs: null
    // opener: options.opener || window
  };

  options = dsf.mix(defaultOptions, options);
  if (options.url.startsWith("#/")) {
    options.url = "./page.html" + options.url;
  }
  options.name = options.name?.trim();
  options.url = dsf.url.getWebPath(options.url, options.root);
  let _self = window;
  // try {
  //   let topWindow=dsf.getTopWindow()
  //   if (topWindow?.dsf) {
  //     _self = topWindow;
  //   }
  // } catch (ex) {
  //   //
  // }
  let windowName =
    (window.windowId ? window.windowId + "." : "") +
    (!options.name ? "dsf-" + dsf.uuid() : options.name);
  //hash路由模式转history模式地址
  options.url = dsf.url.hashRouterToHistoryRouter(options.url);
  let newWin = _self.open(options.url, windowName);
  if (!newWin) {
    console.error("弹窗被意外终止!");
    callback?.();
    return;
  }
  if (windowName === options.name && newWin.location.href !== "about:blank") {
    newWin.location.reload(true);
  }
  if (!newWin.opener.dialogArgs) {
    newWin.opener.dialogArgs = {};
  }
  if (!newWin.opener.openerVms) {
    newWin.opener.openerVms = $openVms;
  }
  newWin.opener.dialogArgs[windowName] = JSON.stringify(options.dialogArgs);
  newWin.opener.openerVms[windowName] = options.openerVm;
  if (options?.openerVm?.$openedWindows) {
    options?.openerVm?.$openedWindows;
  }
  addBeforeUnloadEvent(_self);
  watchOpenWindowClosed(newWin, windowName, _self);
  callback?.(newWin);
  return newWin;
}

//如果当前窗口被关闭或者刷新，则销毁全局所有openerVms的内容
function addBeforeUnloadEvent(self) {
  self.addEventListener("unload", () => {
    try {
      //销毁由当前窗口打开的弹出窗口
      for (let k in self?.openerVms || {}) {
        let vm = self?.openerVms[k];
        if (vm && vm._events) {
          vm?.$destroy?.();
        }
        delete self?.openerVms?.[k];
      }
    } catch (ex) {
      //todo
    }
  });
}

//如果子窗口关闭则销毁与子窗口的关联对象
function watchOpenWindowClosed(newWin, windowName, self) {
  //监听窗口是否关闭，如果关闭了
  if (dsf.isDef(newWin.closed)) {
    let closeId = self.setInterval(() => {
      if (!newWin || newWin.closed) {
        self.clearInterval(closeId);
        try {
          newWin?.document?.querySelector?.("#app")?.__vue__?.$destroy?.();
        } catch (ex) {
          //todo
        }
        delete self.dialogArgs["windowName"];
        delete self.openerVms[windowName];
        delete $openVms[windowName];
        newWin = null;
      }
    }, 3000);
  }
}
